<template>
  <div class="mt-6 side-banner relative flex flex-col gap-y-2">
    <p class="text-[15px] text-black dark:text-white font-semibold pr-24"> Подарочные ĸарты Steam</p>
    <p class="text-black dark:text-white text-[11px] pr-24">
      Для регионов: Турция, США, Аргентина, Европа
      и многих других!
    </p>
    <a
        target="_blank"
        href="https://t.me/geekstore_support"
        class="bg-primary py-2 px-3 min-w-[215px] mr-24 text-white text-[13px] font-semibold rounded"
        @click="trackSteamCardClick"
    >Купить через оператора</a
    ><img src="../assets/img/steam_cards.png" class="absolute -top-4 right-0 w-[106px] h-auto"/>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useYandexMetrika } from 'yandex-metrika-vue3'

const yandexMetrika = useYandexMetrika()

const isShow = ref(false);

const trackSteamCardClick = () => {
    yandexMetrika.reachGoal('STEAM_CARD_CLICK');
}
</script>

<style>
.side-banner {
  @apply rounded py-2 px-3;
  background: linear-gradient(-102.659deg, #66C0F4 0%, #66C0F433 100%);
}
.dark .side-banner {
  background: linear-gradient(-102.659deg, #66C0F4 0%, #1B2838 100%);
}
.side-banner_title_steam {
  color: #fff;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin: 0;
  max-width: 187px;
  text-align: left;
}
.side-banner_text p {
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  margin: 0;
}
.side-banner_img_telegram {
  width: 115px;
  height: 143px;
  position: absolute;
  top: -20px;
  right: -20px;
}
.side-banner_btn_telegram {
  background: #00ff931a;
  color: #00ff93;
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-top: 12px;
  padding: 10px;
  width: 100%;
}
.side-banner_tooltip {
  background: #2a2e3e;
  color: #fff;
  font-size: 14px;
  left: 160px;
  line-height: 18px;
  padding: 12px 20px;
  width: 170px;
  border-radius: 8px;
  position: absolute;
  right: 0;
}
</style>
